import { IContextChildren } from "../../interfaces/context-children.inteface"

export const CattleProofTemplateFullPage = ({children}: IContextChildren) => {
    return (
        <div className='full-height' id="logged-out-state">
            { children }
        </div>
    )
}